import SearchBusinesses from 'components/global/SearchBusinesses';

const LenderSearchBusinesses = () => <SearchBusinesses />;

export default LenderSearchBusinesses;
